import { VendorBuyingAgreementDetailVendor } from '../../../components/Vendor';

export function BuyingAgreement() {
  return <VendorBuyingAgreementDetailVendor />;
}
